<template>
    <div class="container">
        <div class="image-content" v-for="photo in photoList" :key="photo.id">
            <div>
                <img :src="photo.imageUrl">
            </div>
            <div class="del" @click="deletePhoto(photo)">删除</div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import Axios from "axios";
export default {
    data() {
        return {
           photoList: []
        }
    },
    mounted() {
        this.getAllPhoto()
    },
    methods: {
        getAllPhoto() {
            Axios.get(process.env.VUE_APP_BASE_API + '/getAllPhoto').then(req => {
                if (req.data.code === 200) {
                    this.photoList = req.data.photoList
                }
            })
        },
        deletePhoto(photo) {
            Axios.post(process.env.VUE_APP_BASE_API + '/deletePhoto', photo).then(req => {
                if (req.data.code === 200) {
                    this.getAllPhoto()
                }
            })
        }
    }
}
</script>

<style scoped>
.container {
    width: 100%;
    height: 100vh;
    overflow-y: auto;
}
img {
    width: 100%;
    vertical-align: bottom;
}
.image-content {
    width: 80%;
    margin: 5% auto 10%;
    border: 2px solid #011e78;
}
.del {
    width: 30%;
    aspect-ratio: 2.5;
    margin: 3% auto 0;
    background-color: #ee5656;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
